import Title from '@/components/Title';
import { useHostContext } from '@/context/HostContext.tsx';
import { partnerMetadata } from '@/services/PartnerMetadata';
import useAppStore from '@/store/app.ts';
import { cn } from '@/utils';

const AgentIntroContent = () => {
	const { localization } = useHostContext();
	const agentQuery = useAppStore((s) => s.agentQuery);
	const { isMiniCreatorMode } = useHostContext();
	return (
		<div
			className={cn('grid gap-8 sm:gap-12', { '!gap-4': isMiniCreatorMode })}
		>
			<Title
				className="[font-family:var(--font-headlines)] font-semibold m-0 text-primary-900"
				level={1}
				size={isMiniCreatorMode ? 'h5' : 'h3'}
			>
				{agentQuery?.title ? (
					<span>{agentQuery.title}</span>
				) : (
					<span>
						{localization.rich(
							'creator',
							'trainingSourceSelection.title',
							{
								highlight: (chunk) => <span className="highlight">{chunk}</span>
							},
							{
								partnerName: partnerMetadata.getName()
							}
						)}
					</span>
				)}
			</Title>

			<div className="flex flex-col justify-center items-center">
				{agentQuery?.subtitle ? (
					<div
						className="creator-subtitle text-center [font-family:var(--font-body)] font-medium tracking-[-0.3px]
					leading-6 max-w-xl whitespace-pre-wrap"
					>
						{agentQuery.subtitle}
					</div>
				) : (
					<div
						className="creator-subtitle text-center [font-family:var(--font-body)] font-medium tracking-[-0.3px]
					leading-6 max-w-xl whitespace-pre-wrap"
					>
						{localization.translate(
							'creator',
							'trainingSourceSelection.subTitle'
						)}
					</div>
				)}

				<div className="text-balance text-gray-400 text-sm">
					{localization.translate('creator', 'trainingSourceSelection.subText')}
				</div>
			</div>
		</div>
	);
};

export default AgentIntroContent;
